import { render, staticRenderFns } from "./health-sidebar-kpi-item.vue?vue&type=template&id=3ec28b19&scoped=true"
import script from "./health-sidebar-kpi-item.vue?vue&type=script&lang=js"
export * from "./health-sidebar-kpi-item.vue?vue&type=script&lang=js"
import style0 from "./health-sidebar-kpi-item.vue?vue&type=style&index=0&id=3ec28b19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec28b19",
  null
  
)

export default component.exports